import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Coins, Plus, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { TicketCard } from "@/components/Ticket";

function CreditsPanel({ user }) {
  const until = user.subscription_until && new Date(user.subscription_until).toLocaleDateString("it-IT");
  return (
    <div className="surface p-6 relative overflow-hidden" data-testid="credits-panel">
      <div className="stripe-red absolute top-0 left-0 right-0 h-1" />
      <div className="eyebrow mb-3">Il tuo saldo</div>
      <div className="flex items-end gap-3">
        <span className="mono text-6xl font-bold text-white" data-testid="credits-panel-count">{user.credits}</span>
        <span className="text-slate-400 mb-2">crediti</span>
      </div>
      <div className="mt-3 text-sm" data-testid="subscription-status">
        {user.subscription_active ? (
          <span className="text-green-400 flex items-center gap-1.5"><ShieldCheck size={15} /> Abbonamento attivo fino al {until}</span>
        ) : (
          <span className="text-slate-500">Nessun abbonamento attivo</span>
        )}
      </div>
      <Link to="/crediti" className="btn-ghost mt-6 w-full py-2.5 flex items-center justify-center gap-2 text-sm" data-testid="buy-credits-button">
        <Coins size={16} /> Ricarica Crediti / Acquista Supporto
      </Link>
    </div>
  );
}

export default function ClientDashboard() {
  const { user, refreshUser } = useAuth();
  const [tickets, setTickets] = useState(null);
  useEffect(() => {
    refreshUser();
    api.get("/tickets").then(({ data }) => setTickets(data));
  }, [refreshUser]);
  const canOpen = user.credits > 0 || user.subscription_active;
  return (
    <div className="grid lg:grid-cols-[1fr_340px] gap-8">
      <div>
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
          <div>
            <div className="eyebrow mb-2">Area cliente</div>
            <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase" data-testid="client-dashboard-title">Le tue richieste</h1>
          </div>
          <Link to="/nuova-richiesta" className="btn-red px-5 py-3 flex items-center gap-2" data-testid="new-ticket-button">
            <Plus size={18} /> Nuova Richiesta di Supporto
          </Link>
        </div>
        {!canOpen && (
          <div className="surface-2 p-4 mb-6 border-l-4 !border-l-[#E50914] text-sm" data-testid="paywall-notice">
            Per aprire un ticket e prenotare uno slot servono crediti attivi o un abbonamento.{" "}
            <Link to="/crediti" className="text-[#E50914] font-semibold hover:underline">Ricarica ora</Link>
          </div>
        )}
        <div className="space-y-3" data-testid="client-ticket-list">
          {tickets === null && <div className="text-slate-500 text-sm">Caricamento…</div>}
          {tickets?.length === 0 && (
            <div className="surface p-10 text-center text-slate-400" data-testid="empty-tickets">
              Nessuna richiesta ancora. Apri il tuo primo ticket di supporto.
            </div>
          )}
          {tickets?.map((t) => <TicketCard key={t.id} t={t} />)}
        </div>
      </div>
      <div className="space-y-4 lg:sticky lg:top-24 self-start">
        <CreditsPanel user={user} />
        {!user.phone && (
          <Link to="/profilo" className="surface-2 p-4 block text-sm text-amber-300" data-testid="missing-phone-notice">
            Aggiungi il tuo numero WhatsApp nel profilo per ricevere la sessione live.
          </Link>
        )}
      </div>
    </div>
  );
}
